import React from 'react';
import { Nav, Navbar, NavDropdown, NavItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import './ProjectManagerHeader.css';
import logo from '../../../img/logo.png';
import { showStats } from '../../../reducers/currentUser/currentUser.reducer';

export const ProjectManagerHeader = () => (
  <Navbar staticTop >
    <Navbar.Header>
      <Navbar.Brand>
        <a href="/pm" ><img src={logo} alt="logo" className="logo" /> Project Manager</a>
      </Navbar.Brand>
      <Navbar.Toggle />
    </Navbar.Header>
    <Navbar.Collapse>
      <Nav pullLeft >
        <LinkContainer exact to="/pm" ><NavItem>Home</NavItem></LinkContainer>
        <NavDropdown title="DWRs" >
          <LinkContainer to="/pm/dwrs/approved" ><NavItem>Approved</NavItem></LinkContainer>
          <LinkContainer to="/pm/dwrs/submitted" ><NavItem>Submitted</NavItem></LinkContainer>
        </NavDropdown>
        <LinkContainer exact to="/pm/history" ><NavItem>History</NavItem></LinkContainer>
        <LinkContainer exact to="/pm/projects" ><NavItem>Projects</NavItem></LinkContainer>
        {showStats() && <LinkContainer exact to="/pm/stats" ><NavItem>Stats</NavItem></LinkContainer>}
        <LinkContainer to="/logout" ><NavItem>Logout</NavItem></LinkContainer>
      </Nav>
    </Navbar.Collapse>
  </Navbar>
);



// WEBPACK FOOTER //
// ./src/components/ProjectManager/Header/ProjectManagerHeader.jsx